export default ['food', 'weight', 'measurements', 'fitness', 'water'];
